<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
    <div class="content" role="main">
      <div class="facility-heading">Edit Invitation</div>
      <div class="designatedFacilityForm">
              <app-bb-invitation-form [isSubmitted]="isSubmitted" [bbinvitation]="bbinvitation"></app-bb-invitation-form>
<div class="form-buttons">
    <input type="submit" class="submit-form-button" (click)="onSubmit()" value="Submit"/>
    <a routerLink="/bb-invite-list" class="submit-form-button cancel-button">Cancel</a>
  </div>
  </div>
</div>
</div>
<app-footer [bbapp]="true"></app-footer>
